// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.assignment-date__warning[data-v-4b93982c] {\n  width: 100%;\n  margin: 0 auto;\n}\n.assignment-date__warnings[data-v-4b93982c] {\n  padding-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
